import { html } from 'lit';

export const iconCheckboxChecked = html`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="3"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M15.8516 5.64844C16.207 5.97656 16.207 6.55078 15.8516 6.87891L8.85156 13.8789C8.52344 14.2344 7.94922 14.2344 7.62109 13.8789L4.12109 10.3789C3.76562 10.0508 3.76562 9.47656 4.12109 9.14844C4.44922 8.79297 5.02344 8.79297 5.35156 9.14844L8.22266 12.0195L14.6211 5.64844C14.9492 5.29297 15.5234 5.29297 15.8516 5.64844Z"
      fill="white"
    />
  </svg>
`;
